import React, {useState} from 'react';
import {CardBody, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import {useForm} from "react-hook-form";
import {connect, useSelector} from "react-redux";

// labels

// actions

// components
import { ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";
import Switch from "react-bootstrap-switch";
import SelectSupervisor from "../../../components/select/selectSupervisor";
import {getStateByPath} from "../../../redux/selectors";
import {setFilter} from "../../../redux/actions/generics/IndexedActions";


function UserFilters(props) {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { filter } = componentState?.data || {};

    const [enabled, setEnabled] = useState(  null);
    const [passwordExpired, setPasswordExpired] = useState( null);
    const [accountLocked, setAccountLocked] = useState(null);
    const [accountExpired, setAccountExpired] = useState(null);

    const [isSupervisor, setIsSupervisor] = useState(null);
    const [supervisor, setSupervisor] = useState(null);

    const cleanFields = () => {
        setEnabled(null);
        setPasswordExpired(null);
        setAccountLocked(null);
        setAccountExpired(null);
        setIsSupervisor(null);
        setSupervisor(null);
        reset();
    }

    // ----------------------------------------------
    //            SEARCH FILTERS FORM
    // ----------------------------------------------
    const {register, handleSubmit, reset} = useForm({
    });

    const onSubmit = (data, _) => {
        let _filter = {
            ...data,
            enabled : enabled,
            passwordExpired : passwordExpired,
            accountLocked : accountLocked,
            accountExpired : accountExpired,
            isSupervisor : isSupervisor,
        }

        if (supervisor !== undefined && supervisor !== null && supervisor !== '')
            _filter.supervisor = supervisor;

        props.setFilter(path, _filter);
    };

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>Usuario</Label>
                            <Input
                                type="text"
                                name="username"
                                placeholder="Busqueda por Usuario"
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>Nombre</Label>
                            <Input
                                type="text"
                                name="name"
                                placeholder="Busqueda por Nombre"
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>Correo electronico</Label>
                            <Input
                                type="text"
                                name="email"
                                placeholder="Correo electronico"
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>Supervisado por:</Label>
                            <br/>
                            <SelectSupervisor
                                isDisabled={ isSupervisor }
                                assignSupervisor={ setSupervisor }
                                initialSupervisor={ supervisor }
                            />
                        </FormGroup>
                    </Col>

                    <Col md="2">
                        <FormGroup>
                            <Label>Activo</Label>
                            <br/>
                            <Switch animate={true} offText={"No"} onText={"Si"}
                                    innerRef={register}
                                    onChange={_ => setEnabled(!enabled)}
                                    value={enabled}/>
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>¿Es supervidor?</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                innerRef={register}
                                onChange={()=> setIsSupervisor(!isSupervisor)}
                                value={isSupervisor}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>Contraseña expirada</Label>
                            <br/>
                            <Switch animate={true} offText={"No"} onText={"Si"}
                                    innerRef={register}
                                    onChange={_ => setPasswordExpired(!passwordExpired)}
                                    value={passwordExpired}/>
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>Cuenta expirada</Label>
                            <br/>
                            <Switch animate={true} offText={"No"} onText={"Si"}
                                    innerRef={register}
                                    onChange={_ => setAccountExpired(!accountExpired)}
                                    value={accountExpired}/>
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>Cuenta bloqueada</Label>
                            <br/>
                            <Switch animate={true} offText={"No"} onText={"Si"}
                                    innerRef={register}
                                    onChange={_ => setAccountLocked(!accountLocked)}
                                    value={accountLocked}/>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <ButtonSearch />
                        <ButtonClean onClick={() => cleanFields()} />
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = _ => ({
})

const mapActionsToProps = ({
    setFilter
})

export default connect(mapStateToProps, mapActionsToProps)(UserFilters)